module.exports = __webpack_public_path__ + "static/media/safety_datasheets.950eacb7.jpg";